import { Box, Flex, HStack, Image, VStack } from '@chakra-ui/react';
import { useState } from 'react';
import ListenAudio from '../HelperComponents/ListenAudio';
import { getFileUrl, isMobile } from '../Util';
import useMediaOptions from './useMediaOptions';

const MediaItem = ({ media, isSelected, onClick }) => (
  <Box
    onClick={onClick}
    boxShadow={isSelected ? '2px 5px #2367f0' : 'none'}
    borderRadius="10px"
    cursor="pointer"
    border="2px solid black"
    p={1}
    _hover={{ transform: 'scale(1.02)' }}
    transition="transform 0.2s"
  >
    <Image
      boxSize="100%"
      h={['100px', '100px', '200px']}
      w={['100px', '100px', '200px']}
      src={getFileUrl(media.value)}
      alt="Card"
      borderRadius="8px"
      objectFit="cover"
    />
  </Box>
);

const MobileMediaList = ({ mediaList, selectedMedia, onAnswerClick }) => {
  const renderedItems = new Set();
  
  return (
    <VStack spacing={4}>
      {mediaList.map((media, i) => {
        if (renderedItems.has(media.value)) return null;
        
        const nextMedia = mediaList[i + 1];
        renderedItems.add(media.value);
        if (nextMedia) renderedItems.add(nextMedia.value);

        return (
          <HStack key={`${media.key}-${i}`} spacing={4}>
            <MediaItem
              media={media}
              isSelected={selectedMedia === media}
              onClick={() => onAnswerClick(media)}
            />
            {nextMedia && (
              <MediaItem
                media={nextMedia}
                isSelected={selectedMedia === nextMedia}
                onClick={() => onAnswerClick(nextMedia)}
              />
            )}
          </HStack>
        );
      })}
    </VStack>
  );
};

const DesktopMediaList = ({ mediaList, selectedMedia, onAnswerClick }) => (
  <>
    {mediaList.map((media, i) => (
      <MediaItem
        key={`${media.key}-${i}`}
        media={media}
        isSelected={selectedMedia === media}
        onClick={() => onAnswerClick(media)}
      />
    ))}
  </>
);

const ListenWithImage = ({ exercise, setSelectedAnswer }) => {
  const [selectedMedia, setSelectedMedia] = useState(null);
  const { 
    mediaList,
    currentlyPlaying,
    onAudioPlay,
    stopAllAudio
  } = useMediaOptions({ 
    exercise,
    hasAudio: true 
  });

  const handleAnswerClick = (media) => {
    setSelectedMedia(media);
    setSelectedAnswer(media);
  };

  return (
    <VStack spacing={[4, 4, 8]}>
      <HStack justifyContent="center">
        <ListenAudio 
          data={exercise} 
          audioControl={{ 
            currentlyPlaying,
            onAudioPlay,
            stopAllAudio 
          }}
        />
      </HStack>
      
      <Flex
        direction={['column', 'column', 'row']}
        justifyContent="center"
        gap={[4, 4, 6]}
        wrap="wrap"
      >
        {isMobile ? (
          <MobileMediaList
            mediaList={mediaList}
            selectedMedia={selectedMedia}
            onAnswerClick={handleAnswerClick}
          />
        ) : (
          <DesktopMediaList
            mediaList={mediaList}
            selectedMedia={selectedMedia}
            onAnswerClick={handleAnswerClick}
          />
        )}
      </Flex>
    </VStack>
  );
};

export default ListenWithImage;